/**
 * @module rule
 * @description 内容判断相关函数
 * @author: Yawei Wang
 * @date: 2019-06-03 10:22:34
 */

/**
 * @function
 * @desc   判断是否为邮箱地址
 * @param  {String}  str
 * @return {Boolean}
 */
export var isEmail = function isEmail(str) {
  return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(str);
};
/**
 * @function
 * @desc   判断是否为身份证号
 * @param  {String|Number} str
 * @return {Boolean}
 */

export var isIdCard = function isIdCard(str) {
  return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(str);
};
/**
 * @function
 * @desc   判断是否为手机号
 * @param  {String|Number} str
 * @return {Boolean}
 */

export var isPhoneNum = function isPhoneNum(str) {
  return /^(\+?0?86\-?)?1[3456789]\d{9}$/.test(str);
};
/**
 * @function
 * @desc   判断是否为URL地址
 * @param  {String} str
 * @return {Boolean}
 */

export var isUrl = function isUrl(str) {
  return /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(str);
};
/**
 * @function
 * @desc 判断公司名称是否合法
 * @param {String} str
 * @return {String} 错误信息
 */

export var checkCompanyName = function checkCompanyName(str) {
  // 1、不允许出现数字；
  // 2、不允许出现字母；
  // 3、不允许出现关键字：送、元宝、领取、进入、豪礼、微信、微博、月入；  提示语统一显示：公司名称不合法，请重新取名；
  // 4、公司名称长度控制在4~20个汉字内；
  // if (/\d+/g.test(str)) {
  //   return '公司名称不允许出现数字'
  // }
  // if (/[a-zA-Z]+/g.test(str)) {
  //   return '公司名称不允许出现字母'
  // }
  if (!str || str.length < 4 || str.length > 20) {
    return '公司名称长度控制在4~20个汉字内';
  }

  if (/送|元宝|元寶|领取|領取|进入|進入|豪礼|豪禮|微信|微博|月入/g.test(str) || /\d+/g.test(str) || /[a-zA-Z]+/g.test(str) || !new RegExp("^[\u4E00-\u9FA5]{4,20}$", 'g').test(str)) {
    return '公司名称不合法，请重新取名';
  }

  return '';
};
/**
 * @function
 * @desc 判断姓名是否合法
 * @param {String} str
 * @return {String} 错误信息
 */

export var checkUserName = function checkUserName(str) {
  // 1、不允许出现数字；
  // 2、不允许出现字母；
  // 3、字符长度控制在2~5个汉字内；
  if (/\d+/g.test(str)) {
    return '姓名不允许出现数字';
  }

  if (/[a-zA-Z]+/g.test(str)) {
    return '姓名不允许出现字母';
  }

  if (!str || str.length < 2 || str.length > 5) {
    return '字符长度控制在2~5个汉字内';
  }

  if (!new RegExp("^[\u4E00-\u9FA5]{2,5}$", 'g').test(str)) {
    return '姓名不允许有标点和空格';
  }

  return '';
};